import {
	CredentialsState,
	DeviceAuthenticationState as SysApiDeviceAuthenticationState
} from '@shure/shared/angular/data-access/system-api/core';
import {
	DeviceAuthenticationState,
	MissingFeatureType,
	DeviceAuthentication
} from '@shure/shared/angular/data-access/system-api/models';

export function mapDeviceAuthenticationStateFromSysApi(
	credentialsState: CredentialsState | `${CredentialsState}`
): DeviceAuthenticationState {
	switch (credentialsState) {
		case CredentialsState.InitializedNotSet:
		case 'INITIALIZED_NOT_SET':
			return DeviceAuthenticationState.InitializedNotSet;
		case CredentialsState.Set:
		case 'SET':
			return DeviceAuthenticationState.Set;
		case CredentialsState.Uninitialized:
		case 'UNINITIALIZED':
			return DeviceAuthenticationState.Uninitialized;
	}
}

export function mapDeviceAuthenticationFromSysApi(
	sysApiDeviceAuthenticationState: SysApiDeviceAuthenticationState | null | undefined,
	authenticated: boolean | false,
	readonlyModeSelected: boolean | false
): DeviceAuthentication & MissingFeatureType {
	let authentication = {
		isMissing: true,
		authenticated: false,
		state: DeviceAuthenticationState.InitializedNotSet,
		enabled: false,
		readonlyModeSelected: false,
		enabledButNotAuthenticated: false
	};
	if (
		sysApiDeviceAuthenticationState !== undefined &&
		sysApiDeviceAuthenticationState !== null &&
		sysApiDeviceAuthenticationState.credentials !== undefined &&
		sysApiDeviceAuthenticationState.credentials !== null &&
		sysApiDeviceAuthenticationState.credentials.length === 1
	) {
		const state = mapDeviceAuthenticationStateFromSysApi(
			sysApiDeviceAuthenticationState.credentials[0].credentialsState
		);

		const enabled = state === DeviceAuthenticationState.Set;
		const enabledButNotAuthenticated = enabled && !authenticated;
		authentication = {
			authenticated,
			state,
			enabled,
			enabledButNotAuthenticated,
			readonlyModeSelected,
			isMissing: false
		};
	}
	return authentication;
}
